import { getFormattedFundingInterval } from 'helpers/futures';
import {
  estimatedFundingRateState,
  fundingIntervalState,
  fundingRateState,
} from 'selectors/priceSelectors';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';

const useSelectedFuturesProductFunding = () => {
  const fundingRate = fundingRateState();
  const estimatedFunding = estimatedFundingRateState();

  const expiryIntervalFromApi = useAppSelector(
    state => selectedProductSelector(state)?.product_specs?.rate_exchange_interval
  );

  const fundingInterval = (fundingIntervalState() as number) || expiryIntervalFromApi;
  const formattedFundingInterval = getFormattedFundingInterval(fundingInterval);

  return {
    fundingRate,
    estimatedFunding,
    formattedFundingInterval,
    fundingIntervalInHours: parseInt(formattedFundingInterval, 10),
  };
};

export default useSelectedFuturesProductFunding;
